// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__xgDBR","rootCenter":"LoadMoreObserver_rootCenter__3EUME","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1DFOK"};